/**
 * Ermöglich Auswahl der Seiten-Elementen während eines Reviews mit dem WBT-Reviewer
 * @class service_v3sSelectionService
 * @memberOf v3sWbtPlayerApp:annotation
 */

angular.module('v3sWbtPlayerApp').factory('v3sSelectionService', ["$rootScope", "$document", "v3sSearchService", "v3sTimelineService", function ($rootScope, $document, v3sSearchService, v3sTimelineService) {

    var SELECTION_CHANGED = "v3sEventSelectionChanged";
    var selectionMode = false;
    var selection = "";
    var type = ""; // Auswahltyp (leer = Element, "lexikon", ...)
    var elements = {};
    var lexikonElement = null;
    var wasHidden = false;

    $document.bind("click", function (event) {
        if (selectionMode) {
            setSelection(null);
        }
    });

    /**
   * ...
   * @memberOf v3sWbtPlayerApp:annotation.service_v3sSelectionService
   * @param {Object} element - ...
   */
    function getId(element) {
        var id = element[0].id;

        var posRefId = id.indexOf("-");
        if (posRefId > 0) {
            id = id.substr(0, posRefId);
        }

        return id;
    }

    function isHidden(element) {
        if (element.callbacks && element.callbacks.isShown) {
            return !element.callbacks.isShown();
        }

        var visibility = element.element.css("visibility");

        // Angular liest nur inline-Styles aus, ggf. manuell auslesen
        if (!visibility) {
            visibility = getComputedStyle(element.element[0]).getPropertyValue("visibility");
        }

        return visibility == "hidden";
    }

    function addHoverEffect(element, id) {
        element.on('mouseenter', function () {
            if (selectionMode) {
                element.addClass("annotationHover");
                element.attr("title", id);
            }
        });

        element.on('mouseleave', function () {
            if (selectionMode) {
                element.removeClass("annotationHover");
                element.attr("title", "");
            }
        });
    }

    /**
     * Fügt ein Element zur Liste der selektierbaren Elemente hinzu
     * @memberOf v3sWbtPlayerApp:annotation.service_v3sSelectionService
     * @param {Object} element - das Element
     * @param {Object} callbacks - callbacks zum Zeigen und Verstecken des Elements: { show: ..., hide: ... }
     */
    function addElement(element, callbacks) {
        var id = getId(element);

        if (!elements[id]) {
            elements[id] = [];
        }

        elements[id].push({
            element: element,
            callbacks: callbacks
        });

        element.bind("click", function (event) {
            if(selectionMode) {
                // Schließen-Knöpfe entfernen das Element, deshalb nicht auswählen
                if (!angular.element(event.target).hasClass("close")) {
                    setSelection(id);
                }
                event.stopPropagation();
                event.preventDefault();
            }
        });

        addHoverEffect(element, id);
    }

    /**
   * ...
   * @memberOf v3sWbtPlayerApp:annotation.service_v3sSelectionService
   * @param {Object} element - ...
   */
    function removeElement(element) {
        var id = getId(element);

        if (!!elements[id]) {
            var arrayWithoutElement = [];
            angular.forEach(elements[id].element, function (aElement) {
                if (aElement[0].id != element[0].id) {
                    arrayWithoutElement.push(aElement);
                }
            });
            elements[id].element = arrayWithoutElement;
        }
    }

   /**
    * Setzt das Element mit dem aktuell angezeigten Lexikoneintrag.
    * @memberOf v3sWbtPlayerApp:annotation.service_v3sSelectionService
    * @param {Object} element - ...
    */
    function setLexikonElement(element) {
        var id = getId(element);

        element.bind('click', function (event) {
            if (selectionMode) {
                setSelection(id, "lexikon");
                event.stopPropagation();
                event.preventDefault();
            }
        });

        addHoverEffect(element, id);

        lexikonElement = element;

        if (selection && type == "lexikon" && element && id == selection) {
            lexikonElement.addClass("annotationSelected");
        }
    }

    /**
    * ...
    * @memberOf v3sWbtPlayerApp:annotation.service_v3sSelectionService
    */
    function destroy() {
        setSelection(null);
        elements = {};
    }

    /**
    * ...
    * @memberOf v3sWbtPlayerApp:annotation.service_v3sSelectionService
    * @returns {Array} Selektierbare Elemente
    */
    function getSelectableElements() {
        return Object.keys(elements);
    }

    /**
    * ...
    * @memberOf v3sWbtPlayerApp:annotation.service_v3sSelectionService
    * @param {bool} mode - ...
    */
    function setActive(mode) {
        if (!mode) {
            setSelection(null);
        }
        selectionMode = mode;
    }

    /**
    * ...
    * @memberOf v3sWbtPlayerApp:annotation.service_v3sSelectionService
    * @returns {bool} Selektion aktiv
    */
    function getActive() {
        return selectionMode;
    }

    /**
    * ...
    * @memberOf v3sWbtPlayerApp:annotation.service_v3sSelectionService
    * @param {Object} element - ...
    */
    function setSelection(id, selectionType) {
        if (selection == id || !selection && !id) {
            return;
        }

        var oldSelection = selection;
        var oldType = type;

        type = selectionType;

        if (!!id && (!!type || !!elements[id])) {
            selection = id;
        } else {
            selection = "";
        }

        // Auswahl nur im Auswahlmodus auch tatsächlich anzeigen
        if (selectionMode) {
            if (!!oldSelection) {
                if (!oldType) {
                    angular.forEach(elements[oldSelection], function (element) {
                        element.element.removeClass("annotationSelected");

                        if (wasHidden) {
                            if (element.callbacks && element.callbacks.hide) {
                                element.callbacks.hide();

                            } else {
                                var action = {
                                    object: oldSelection,
                                    command: "hide"
                                };

                                v3sTimelineService.addAsyncAction(action);
                            }
                        }
                    });

                } else if (oldType == "lexikon") {
                    if (wasHidden) {
                        v3sSearchService.hideLexikonEntry();
                    }

                    if (lexikonElement) {
                        lexikonElement.removeClass("annotationSelected");
                    }
                }
            }

            wasHidden = false;

            if (!!selection) {
                if (!type) {
                    angular.forEach(elements[selection], function (element) {
                        element.element.addClass("annotationSelected");

                        if (isHidden(element) && (!element.callbacks || !element.callbacks.show)) {
                            var action = {
                                object: id,
                                command: "show"
                            };

                            v3sTimelineService.addAsyncAction(action);

                            wasHidden = true;

                        } else if (element.callbacks && element.callbacks.show) {
                            wasHidden = element.callbacks.show();
                        }
                    });

                } else if (type == "lexikon") {
                    if (lexikonElement && getId(lexikonElement) == selection) {
                        lexikonElement.addClass("annotationSelected");
                        wasHidden = false;

                    } else {
                        v3sSearchService.init().then(function () {
                            wasHidden = v3sSearchService.showLexikonEntry(id);
                            lexikonElement.addClass("annotationSelected");
                        });
                    }
                }
            }
        }

        $rootScope.$emit(SELECTION_CHANGED, selection, type);
    }

    /**
    * ...
    * @memberOf v3sWbtPlayerApp:annotation.service_v3sSelectionService
    * @returns {Object} Selektiertes Element
    */
    function getSelection() {
        return selection;
    }

    /**
    * ...
    * @memberOf v3sWbtPlayerApp:annotation.service_v3sSelectionService
    * @returns {Object} Art der Auswahl (leer für Element, "lexikon" für Lexikon)
    */
    function getType() {
        return type;
    }

    /**
    * ...
    * @memberOf v3sWbtPlayerApp:annotation.service_v3sSelectionService
    * @param {function} handler - ...
    */
    function onSelectionChanged($scope, handler) {
        var listener = $rootScope.$on(SELECTION_CHANGED, function (event, selection, type) {
            handler(selection, type);
        });
        $scope.$on('$destroy', listener);
    };

    return {
        addElement: addElement,
        removeElement: removeElement,
        destroy: destroy,
        getSelectableElements: getSelectableElements,
        setActive: setActive,
        getActive: getActive,
        setSelection: setSelection,
        getSelection: getSelection,
        onSelectionChanged: onSelectionChanged,
        setLexikonElement: setLexikonElement
    }
}]);